

import "../Css/groovePQR_pdf.css";
import TTS_pdf_headerWPQpage1 from "./TTS_pdf_headerPQRpage1";
import PQRBaseMetalTable from "./common/PQRBaseMetalTable";
import PQR_Footer from "./PQR_Footer";


const PQRTubeToTubesheet_pdf_page1 = (
  {
    pdf,
    previewUrl1,
    previewUrl2,
    previewUrl3,
    previewuser,
    previewapproved,
  },
  props,
  wld
) => {

  const width = "72.6%";

  const col1Class1 = "PQRpdfLeftBorder aligncenter";

  const styles = {
    container: {
      display: "flex",
    },

    group: {
      display: "flex",
    },

    title3: {
      width: "50%",
    },
  };

  const renderTableCell = (value) => value !== "" ? value : "--";

  function Certification() {
    const rows = [];
    for (let i = 0; i < pdf.length; i++) {
      const visualExamination = pdf[i]?.Certification || [];
      for (let j = 0; j < visualExamination.length; j++) {
        const item = visualExamination[j];
        rows.push(
          <tr key={`${i}-${j}`} style={{height:"12px"}}>
            <td style={{border:"1px solid black", borderTop:"none", fontSize:"7.6px", textAlign:"center", padding:"0px 3px", backgroundColor:"white"}}>
              {item.PQR_Certification_Welder_Name !== "" ? item.PQR_Certification_Welder_Name : "--"}
            </td>
            <td style={{border:"1px solid black", borderTop:"none", borderLeft:"none", fontSize:"7.6px", textAlign:"center", padding:"0px 3px", backgroundColor:"white"}}>
              {item.PQR_Certification_ID !== "" ? item.PQR_Certification_ID : "--"}
            </td>
            <td style={{border:"1px solid black", borderTop:"none", borderLeft:"none", fontSize:"7.6px", textAlign:"center", padding:"0px 3px", backgroundColor:"white"}}>
              {item.PQR_Certification_Process !== "" ? item.PQR_Certification_Process : "--"}
            </td>
          </tr>
        );
      }
    }
    return rows;
  }
  
  function CertificationLabRef() {
    const rows = [];
    for (let i = 0; i < pdf.length; i++) {
      const visualExamination = pdf[i]?.CertificationLabRef || [];
      for (let j = 0; j < visualExamination.length; j++) {
        const item = visualExamination[j];
        rows.push(
          <tr key={`${i}-${j}`} style={{ height: "12px" }}>
            <td colSpan={2} style={{ border:"1px solid black", borderTop:"none", fontSize:"7.6px", textAlign:"left", padding:"0px 3px", backgroundColor:"white" }}>
              {item.PQR_Certification_Lab_RefNo !== "" ? item.PQR_Certification_Lab_RefNo : "--"}
            </td>
          </tr>
        );
      }
    }
    return rows;
  }


  return (
    <div className="PQRMainPDF">
      <TTS_pdf_headerWPQpage1 pdf={pdf}></TTS_pdf_headerWPQpage1>

      <PQRBaseMetalTable pdf={pdf} type="Tubesheet" />
     
      <div style={styles.group}>
        <div className="PQRbasemetal">JOINT DETAIL</div>

      </div>
            <div style={styles.group}>
        <div className="PQRemptyTitle" style={{ width: "31%" }}></div>  
      </div>
      <div style={styles.container}>
        <table id="table" className="PQRTable2">
        <tbody>
      <th className="PQR_border" style={{width: "25%"}}>
        Joint Type	<br></br>
        Tube Pitch         <div className="PQRrcorner"> mm </div><br></br>
        Tube Projection       <div className="PQRrcorner"> mm </div> <br></br>
        Pattern
      </th>
      <td className="PQR_noleft" style={{ width: "25%",textAlign:"left"}}>
        <span className="PQRforfontJD" >{pdf[0]?.PQR_JD_JointType} </span>
        <br />
        <span className="PQRforfontJD">{pdf[0]?.PQR_JD_TubePitch} </span>
        <br />
        <span className="PQRforfontJD">{pdf[0]?.PQR_JD_TubeProj} </span>
        <br />
        <span className="PQRforfontJD">{pdf[0]?.PQR_JD_Pattern} </span>
        <br />  </td>
      <th style={{width: "25%"}} className="PQR_noleft">
        Hole Id                  <div className="PQRrcorner"> mm </div>	<br></br>
        Groove depth             <div className="PQRrcorner"> mm </div>
        <br></br>
        Width of the ligament  <div className="PQRrcorner"> mm </div>
         <br></br>
         Groove Angle(°)/Radius(mm)        
      </th>
      <td className="PQR_noleft" style={{textAlign:"left"}}>
        <span className="PQRforfontJD">{pdf[0]?.PQR_JD_HoleId} </span>
        <br />
        <span className="PQRforfontJD">{pdf[0]?.PQR_JD_GrooveDepth} </span>
        <br />
        <span className="PQRforfontJD">{pdf[0]?.PQR_JD_WidthLigament} </span>
        <br />
        <span className="PQRforfontJD">{pdf[0]?.PQR_JD_GrooveAngle} </span>
        <br />  </td>
      <tr>
        <th className="PQR_border" style={{textAlign:"left", borderTop:"none", borderBottom:"none"}}>Notes</th>
        <td className="PQR_noleft" style={{textAlign:"left", wordBreak:"break-word", borderTop:"none", borderBottom:"none"}} colSpan={3}>
          {pdf[0]?.PQR_JD_Notes}
        </td>
      </tr>
      </tbody>
        </table>
      </div>

      <div style={{margin:0, padding:0}}>
        <table
          className="PQRTablePg2  " 
          style={{  width: "570px"}} >
          <tbody>
            <tr>
              <th className="PQR_border" style={{ width: "30%" }}>
                Tube Hole Ligament Detail
              </th>
              <th className="PQR_noleft"
                style={{
                  width: "30%" }} >
                Tube Hole Detail
              </th>
              <th className="PQR_noleft"
                style={{
                  padding: "1px 4px",
                  width: "30%",
                 }} >
                Tube to Tubesheet Weld Joint Detail
              </th>
            </tr>

            <tr >
              <td className="TTSimg PQR_noTop" style={{height:"80px"}}>
              
                {previewUrl1 && ( 
                  <img
                    className="PQRimgsizebig" 
                    style={{ marginTop: "2%", marginLeft: "2%" ,marginBottom:"2%" ,marginRight:"2%" }}
                    src={previewUrl1}
                    alt="image"
                  />
                )}
              </td>
              <td className="TTSimg PQR_Botmrt" style={{height:"80px"}}>
            
                {previewUrl2 && (
                  <img
                    className="PQRimgsizebig"
                    style={{ marginTop: "2%", marginLeft: "2%" ,marginBottom:"2%" ,marginRight:"2%" }}
                    src={previewUrl2}
                  />
                )}
              </td>
              <td className="PQR_Botmrt TTSimg" style={{height:"80px"}}>
            
                {previewUrl3 && (
                  <img
                    className="PQRimgsizebig"
                    style={{ marginTop: "2%", marginLeft: "2%" ,marginBottom:"2%" ,marginRight:"2%" }}
                    src={previewUrl3}
                  />
                )}
              </td>
            </tr>
            <tr>
              <th className="PQR_noTop" scope="row" style={{textAlign:"left"}}>
                Notes
              </th>
              <td className="PQR_right PQR_Botm" style={{textAlign:"left"}} colSpan={2}>
                {pdf[0]?.PQR_Image_Notes}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
     

<div style={styles.group}>
  <div className="PQRbasemetal">FILLER METALS (QW-404)</div>
</div><div style={styles.container}>
    <table id="table" className="PQRTable2" >
      <tbody>
            <tr>
               <td style={{width:"20%"}}></td>
              <th style={{textAlign:"center"}} className="PQR_noRgt">SFA</th>
              <th style={{textAlign:"center"}} className="PQR_topBotm">Classification</th>
              <th style={{textAlign:"center"}} className="PQR_topBotm"> F-no</th>
              <th style={{textAlign:"center"}} className="PQR_topBotm"> A-no</th>
              <th style={{textAlign:"center"}} className="PQR_noleft"> Chemical Analysis or Trade name</th>
            </tr>
            <tr>
              <th className="PQR_border" >GTAW </th>
              <td className="PQR_Botm"> {pdf[1]?.WPSD_FM_SFA} </td>
              <td className="PQR_Botm">{pdf[1]?.WPSD_FM_Classification}</td>
              <td className="PQR_Botm">{pdf[1]?.WPSD_FM_FNo}</td>
              <td className="PQR_Botm">{pdf[1]?.WPSD_FM_Ano}</td>
              <td className="PQR_rt_botm"> {pdf[1]?.WPSD_FM_ChemicalAnalysis_TradeName}</td>
            </tr>

                    </tbody>
        </table>
      </div>

      {/* <!-- --------------------------Welding Procedure----------------------------------------------- --> */}
       

      <div className="PQRbasemetal" >WELDING PROCEDURE</div>
        <table id="table" className="PQRTable8"  >
        <tr  style={{ borderTop: ".1px solid black"}}>
          <th 
            className="PQRpdfLeftBorder "
            style={{ borderTop: ".1px solid black", width: "30%" }}
          >
            Welding Process & Type
          </th>
          <td className={col1Class1} colSpan={3}>{pdf[1]?.PQRD_WP_WeldingProcess}</td>
        </tr>
        <tr>
          <th 
            className="PQRpdfLeftBorder "
            style={{ width: "30%" }}
          >
           Min. Preheat Temperature
           <div className="PQRcorner"> °C </div>
          </th>
          <td className={col1Class1} colSpan={3}>{pdf[1]?.PQRD_WP_MinimumPreheatTemp}</td>
        </tr>
        <tr >
          <th className="PQRpdfLeftBorder">
          Max. Interpass temperature
            <div className="PQRcorner"> °C </div>
          </th>
          <td className={col1Class1} colSpan={3}>{pdf[1]?.PQRD_WP_MaximumInterpassTemp}</td>
        </tr>
      
        <tr >
          <th className="PQRpdfLeftBorder ">Post Heating / DHT</th>
          <td className={col1Class1} colSpan={3}>{pdf[1]?.PQRD_WP_PostHeating}</td>
        </tr>
        <tr >
          <th className="PQRpdfLeftBorder ">
          Tungsten  Type & Size 
            <div className="PQRcorner"> mm </div>
          </th>

          <td className={col1Class1} colSpan={3}>{pdf[1]?.PQRD_WP_TungstenType}</td>
        </tr>{" "}
        <tr >
          <th className="PQRpdfLeftBorder ">Welding Position	</th>
          <td className={col1Class1} colSpan={3}>{pdf[1]?.PQRD_WP_WeldPosition}</td>
        </tr>
        <tr >
          <th className="PQRpdfLeftBorder ">Progression</th>

          <td className={col1Class1} colSpan={3}>{pdf[1]?.PQRD_WP_WeldProgression}</td>
        </tr>
        <tr >
          <th className="PQRpdfLeftBorder ">No of Passes</th>

          <td className={col1Class1} colSpan={3}>{pdf[1]?.PQRD_WP_NoofPasses}</td>
        </tr>
        <tr >
          <th className="PQRpdfLeftBorder ">Layer Number</th>

          <td className={col1Class1} id="weldpdata3">   
            
              {pdf[1]?.PQRD_WP_LayerNo?.[0]?.Value_A?.[0] || "--"}{" "}
            </td>
            <td className={col1Class1}>
              {" "}
              {pdf[1]?.PQRD_WP_LayerNo?.[1]?.Value_B?.[0] || "--"}
             </td>
            <td className={col1Class1}>
              {" "}
              {pdf[1]?.PQRD_WP_LayerNo?.[2]?.Value_C?.[0] || "--"}
             </td>
        </tr>
        <tr >
          <th className="PQRpdfLeftBorder ">
            Filler Metal Size(Ø)
            <div className="PQRcorner"> mm </div>
          </th>

          <td className={col1Class1} id="weldpdata3">  
           
              {pdf[1]?.PQRD_WP_FillerMetalSize?.[0]?.Value_A?.[0] || "--"}{" "}
            </td>
            <td className={col1Class1}>
              {" "}
              {pdf[1]?.PQRD_WP_FillerMetalSize?.[1]?.Value_B?.[0] || "--"}
            </td>
            <td className={col1Class1}>
              {" "}
              {pdf[1]?.PQRD_WP_FillerMetalSize?.[2]?.Value_C?.[0] || "--"}
          </td>
        </tr>
        <tr >
          <th className="PQRpdfLeftBorder ">Amperes 
          <div className="PQRcorner"> Amps</div> </th>

          <td className={col1Class1} id="weldpdata3">
            
              {pdf[1]?.PQRD_WP_Amperes?.[0]?.Value_A?.[0] || "--"}{" "}
           </td>
              <td className={col1Class1}>
              {" "}
              {pdf[1]?.PQRD_WP_Amperes?.[1]?.Value_B?.[0] || "--"}
            </td>
            <td className={col1Class1}>
              {" "}
              {pdf[1]?.PQRD_WP_Amperes?.[2]?.Value_C?.[0] || "--"}
          </td>
        </tr>
        <tr >
          <th className="PQRpdfLeftBorder ">DC pulsing Current
          <div className="PQRcorner"> Amps</div> </th>

          <td className={col1Class1} id="weldpdata3">
            
              {pdf[1]?.PQRD_WP_DC_Pulsing_current?.[0]?.Value_A?.[0] || "--"}{" "}
        </td>
            <td className={col1Class1}>
              {" "}
              {pdf[1]?.PQRD_WP_DC_Pulsing_current?.[1]?.Value_B?.[0] || "--"}
            </td>
            <td className={col1Class1}>
              {" "}
              {pdf[1]?.PQRD_WP_DC_Pulsing_current?.[2]?.Value_C?.[0] || "--"}
          </td>
        </tr>
        <tr >
          <th className="PQRpdfLeftBorder ">DC pulsing Current - Others
          <div className="PQRcorner"> Amps</div> </th>

          <td className={col1Class1} id="weldpdata3">
            
              {pdf[1]?.PQRD_WP_DC_Pulsing_current_Others?.[0]?.Value_A?.[0] || "--"}{" "}
        </td>
            <td className={col1Class1}>
              {" "}
              {pdf[1]?.PQRD_WP_DC_Pulsing_current_Others?.[1]?.Value_B?.[0] || "--"}
            </td>
            <td className={col1Class1}>
              {" "}
              {pdf[1]?.PQRD_WP_DC_Pulsing_current_Others?.[2]?.Value_C?.[0] || "--"}
          </td>
        </tr>
       
        <tr >
          <th className="PQRpdfLeftBorder ">Voltage  <div className="PQRcorner"> Volts</div></th>
          <td className={col1Class1}>
 
              {pdf[1]?.PQRD_WP_Volatage_Volts?.[0]?.Value_A?.[0] || "--"}{" "}

          </td>
          <td className={col1Class1}>
              {" "}
              {pdf[1]?.PQRD_WP_Volatage_Volts?.[1]?.Value_B?.[0] || "--"}

          </td>
          <td className={col1Class1}>
              {" "}
              {pdf[1]?.PQRD_WP_Volatage_Volts?.[2]?.Value_C?.[0] || "--"}

          </td>
        </tr>
        <tr >
          <th className="PQRpdfLeftBorder ">Heat Input
          <div className="PQRcorner"> KJ/mm</div> </th>

          <td className={col1Class1} id="weldpdata3">
  
              {pdf[1]?.PQRD_WP_Heat_Input?.[0]?.Value_A?.[0] || "--"}{" "}
          </td>
          <td className={col1Class1}>

              {" "}
              {pdf[1]?.PQRD_WP_Heat_Input?.[1]?.Value_B?.[0] || "--"}

          </td>
          <td className={col1Class1}>

              {" "}
              {pdf[1]?.PQRD_WP_Heat_Input?.[2]?.Value_C?.[0] || "--"}

          </td>
        </tr>
        <tr >
          <th className="PQRpdfLeftBorder ">Travel Speed 
          <div className="PQRcorner"> mm/min</div></th>

          <td className={col1Class1} id="weldpdata3">

              {pdf[1]?.PQRD_WP_Travel_Speed?.[0]?.Value_A?.[0] || "--"}{" "}
          </td>
          <td className={col1Class1}>
              {" "}
              {pdf[1]?.PQRD_WP_Travel_Speed?.[1]?.Value_B?.[0] || "--"}

          </td>
          <td className={col1Class1}>
              {" "}
              {pdf[1]?.PQRD_WP_Travel_Speed?.[2]?.Value_C?.[0] || "--"}

          </td>
        </tr>
       
        <tr >
          <th className="PQRpdfLeftBorder ">Polarity or current type</th>
          <td className={col1Class1} id="weldpdata3">
              {pdf[1]?.PQRD_WP_PolarityOrCurrent?.[0]?.Value_A?.[0] || "--"}{" "}
          </td>
          <td className={col1Class1} colSpan={2}>
              {" "}
              {pdf[1]?.PQRD_WP_PolarityOrCurrent?.[1]?.Value_B?.[0] || "--"}
          </td>
        </tr>
        <tr >
          <th className="PQRpdfLeftBorder ">Automatic Arc Voltage control</th>

          <td className={col1Class1} colSpan={3}>{pdf[1]?.PQRD_WP_ArcVoltageControl}</td>
        </tr>
        <tr >
          <th className="PQRpdfLeftBorder ">Shielding Gas Type - <div className="PQRcorner"> %Comp</div>  	<br></br>	 <div className="PQRmidGas" style={{paddingLeft:"42px"}}>Flow Rate - 
          <div className="PQRrcorner" style={{paddingLeft:"30px"}}>l/min</div> </div></th>

          <td className={col1Class1} colSpan={3}>
            {pdf[1]?.PQRD_WP_ShieldingGasType} <br></br>
            {pdf[1]?.PQRD_WP_ShieldingFlowRate}
          </td>
        </tr>
        <tr >
          <th className="PQRpdfLeftBorder ">Auxiliary gas shield system.</th>
          <td className={col1Class1} colSpan={3}>{pdf[1]?.PQRD_WP_Auxiliarygas}</td>
        </tr>
        <tr >
          <th className="PQRpdfLeftBorder ">Expansion</th>
          <td className={col1Class1} colSpan={3}>{pdf[1]?.PQRD_WP_Expansion}</td>
        </tr>
        <tr>
          <th className="PQRpdfLeftBorder" style={{borderBottom:"none"}}>Method of cleaning</th>
          <td className={col1Class1} colSpan={3} style={{borderBottom:"none"}}>{pdf[1]?.PQRD_WP_MethodofCleaning}</td>
        </tr>
      </table>

      <table id="table" className="PQRTable8" style={{position:"relative", top:"-1px", width:"570px", tableLayout:"fixed"}}>
        <colgroup>
          <col style={{width:"30%"}} />
          <col style={{width:"35%"}} />
          <col style={{width:"35%"}} />
        </colgroup>
        <tr>
          <th className="PQRpdfLeftBorder">Single/Multi Electrode</th>
          <td className={col1Class1}>{Array.isArray(pdf[1]?.PQRD_WP_SingleMultiElectrode) ? pdf[1]?.PQRD_WP_SingleMultiElectrode[0] : pdf[1]?.PQRD_WP_SingleMultiElectrode || "--"}</td>
          <td className={col1Class1}>{Array.isArray(pdf[1]?.PQRD_WP_SingleMultiElectrode) ? pdf[1]?.PQRD_WP_SingleMultiElectrode[1] : "--"}</td>
        </tr>
        <tr>
          <th className="PQRpdfLeftBorder">Peening</th>
          <td className={col1Class1}>{Array.isArray(pdf[1]?.PQRD_WP_Peening) ? pdf[1]?.PQRD_WP_Peening[0] : pdf[1]?.PQRD_WP_Peening || "--"}</td>
          <td className={col1Class1}>{Array.isArray(pdf[1]?.PQRD_WP_Peening) ? pdf[1]?.PQRD_WP_Peening[1] : "--"}</td>
        </tr>
        <tr>
          <th className="PQRpdfLeftBorder">Use of Thermal Process</th>
          <td className={col1Class1}>{Array.isArray(pdf[1]?.PQRD_WP_ThermalProcess) ? pdf[1]?.PQRD_WP_ThermalProcess[0] : pdf[1]?.PQRD_WP_ThermalProcess || "--"}</td>
          <td className={col1Class1}>{Array.isArray(pdf[1]?.PQRD_WP_ThermalProcess) ? pdf[1]?.PQRD_WP_ThermalProcess[1] : "--"}</td>
        </tr>
        <tr>
          <th className="PQRpdfLeftBorder">String &amp; Weave</th>
          <td className={col1Class1}>{Array.isArray(pdf[1]?.PQRD_WP_StringWeave) ? pdf[1]?.PQRD_WP_StringWeave[0] : pdf[1]?.PQRD_WP_StringWeave || "--"}</td>
          <td className={col1Class1}>{Array.isArray(pdf[1]?.PQRD_WP_StringWeave) ? pdf[1]?.PQRD_WP_StringWeave[1] : "--"}</td>
        </tr>
        <tr>
          <th className="PQRpdfLeftBorder">Oscillation</th>
          <td className={col1Class1}>{Array.isArray(pdf[1]?.PQRD_WP_Oscillation) ? pdf[1]?.PQRD_WP_Oscillation[0] : pdf[1]?.PQRD_WP_Oscillation || "--"}</td>
          <td className={col1Class1}>{Array.isArray(pdf[1]?.PQRD_WP_Oscillation) ? pdf[1]?.PQRD_WP_Oscillation[1] : "--"}</td>
        </tr>
        <tr>
          <th className="PQRpdfLeftBorder">Orifice Cup Size in mm</th>
          <td className={col1Class1}>{Array.isArray(pdf[1]?.PQRD_WP_OrificeCupSize) ? pdf[1]?.PQRD_WP_OrificeCupSize[0] : pdf[1]?.PQRD_WP_OrificeCupSize || "--"}</td>
          <td className={col1Class1}>{Array.isArray(pdf[1]?.PQRD_WP_OrificeCupSize) ? pdf[1]?.PQRD_WP_OrificeCupSize[1] : "--"}</td>
        </tr>
        <tr style={{borderBottom:"1px solid black"}}>
          <th className="PQRpdfLeftBorder" style={{borderBottom:"1px solid black"}}>Closed to Out Chamber</th>
          <td className={col1Class1} style={{borderBottom:"1px solid black"}}>{Array.isArray(pdf[1]?.PQRD_WP_ClosedOutChamber) ? pdf[1]?.PQRD_WP_ClosedOutChamber[0] : pdf[1]?.PQRD_WP_ClosedOutChamber || "--"}</td>
          <td className={col1Class1} style={{borderBottom:"1px solid black"}}>{Array.isArray(pdf[1]?.PQRD_WP_ClosedOutChamber) ? pdf[1]?.PQRD_WP_ClosedOutChamber[1] : "--"}</td>
        </tr>
      </table>


{/* --------------------------post weld heat--------------------------------------------------------------------- */}
<div style={styles.group}>
  <div className="PQRbasemetal">POST WELD HEAT TREATMENT(QW-407)</div>
  </div>
  <div style={styles.container}>
<table id="table" className="PQRTable2">
<tbody>
  <tr>
    <th style={{width: "16%"}} className="PQR_border">
    Temperature   <div className="PQRrcorner">°C </div>
      <br />
    Heating rate  <div className="PQRrcorner">°C/Hr </div>
    </th>
    <td style={{ width: "13%"}} className="PQR_noleft">
      <span className="PQRforfont" style={{ float: "left" }}>
        {pdf[0]?.PQR_PWHeatTre_Temperature}
      </span>
      <br />
      <span className="PQRforfont" style={{ float: "left" }}>
        {pdf[0]?.PQR_PWHeatTre_Heating_Rate}
      </span>
      
    </td>
    <th style={{width: "16%"}} className="PQR_noleft">
     Time  Minutes
     <br />
    Cooling rate  <div className="PQRrcorner">°C/Hr </div>
    </th>
    <td style={{ width: "17%" }} className="PQR_noleft">
      <span className="PQRforfont" style={{ float: "left"  }}>
        {pdf[0]?.PQR_PWHeatTre_Time}
      </span>
      <br />
      <span className="PQRforfont" style={{ float: "left" }}>
        {pdf[0]?.PQR_PWHeatTre_Cooling_Rate}
      </span>
    
    </td>
    <th style={{width: "15%"}} className="PQR_noleft">
    Type
    </th>
    <td style={{ width: "13%" }} className="PQR_noleft">
      <span className="PQRforfont" style={{ float: "left"  }}>
        {pdf[0]?.PQR_PWHeatTre_Type}
      </span>
      <br />
    </td>
  </tr>
  <tr>
              <th className="PQR_noTop"
                scope="row">  Notes
              </th> 
              <td className="Noteswrap PQR_rt_botm" colspan="5" style={{textAlign:"left"}} >
                  {pdf[0]?.PQR_PWHeatTre_Notes != undefined
                    ? pdf[0]?.PQR_PWHeatTre_Notes.split("\n").map((i) => {
                        return (
                          <>
                            {i}

                            <br></br>
                          </>
                        );
                      })
                    : ""}
                </td>
            </tr> 
</tbody>
</table></div>

{/* ----------------------------------Certification ------------------------------------------------------------- */}
<div className="group" style={{position:"relative", zIndex:10}}>
            <div className="PQRbasemetal" style={{ width: { width } }}>
            CERTIFICATION
            </div>
          </div>

          <div style={{ width: "570px", position:"relative", zIndex:10 }}>
            <table style={{ width: "570px", borderCollapse:"collapse", fontSize:"7.6px", fontFamily:"var(--font-regular)" }}>
              <tr>
                <th style={{ width: "130px", border:"1px solid black", backgroundColor:"var(--col-ddd)", fontWeight:"normal", textAlign:"center", padding:"1px 3px" }}>Welders Name</th>
                <th style={{ width: "80px", border:"1px solid black", borderLeft:"none", backgroundColor:"var(--col-ddd)", fontWeight:"normal", textAlign:"center", padding:"1px 3px" }}>Id</th>
                <th style={{ width: "100px", border:"1px solid black", borderLeft:"none", backgroundColor:"var(--col-ddd)", fontWeight:"normal", textAlign:"center", padding:"1px 3px" }}>Process</th>
                <th style={{ width: "120px", border:"1px solid black", borderLeft:"none", backgroundColor:"var(--col-ddd)", fontWeight:"normal", textAlign:"left", padding:"1px 3px" }}>Tests conducted by</th>
                <td style={{ border:"1px solid black", borderLeft:"none", textAlign:"left", padding:"1px 3px", backgroundColor:"white" }}>{pdf[0]?.PQR_Certification_ConductedBy}</td>
              </tr>
              <tr style={{height:"10px"}}>
                <td style={{border:"1px solid black", borderTop:"none", fontSize:"7.6px", textAlign:"center", padding:"0px 3px", backgroundColor:"white"}}>{pdf[0]?.Certification?.[0]?.PQR_Certification_Welder_Name || "--"}</td>
                <td style={{border:"1px solid black", borderTop:"none", borderLeft:"none", fontSize:"7.6px", textAlign:"center", padding:"0px 3px", backgroundColor:"white"}}>{pdf[0]?.Certification?.[0]?.PQR_Certification_ID || "--"}</td>
                <td style={{border:"1px solid black", borderTop:"none", borderLeft:"none", fontSize:"7.6px", textAlign:"center", padding:"0px 3px", backgroundColor:"white"}}>{pdf[0]?.Certification?.[0]?.PQR_Certification_Process || "--"}</td>
                <th style={{ border:"1px solid black", borderTop:"none", borderLeft:"none", backgroundColor:"var(--col-ddd)", fontWeight:"normal", textAlign:"left", padding:"0px 3px" }} colSpan={2}>Laboratory ref. number</th>
              </tr>
              <tr style={{height:"10px"}}>
                <td style={{border:"1px solid black", borderTop:"none", fontSize:"7.6px", textAlign:"center", padding:"0px 3px", backgroundColor:"white"}}>{pdf[0]?.Certification?.[1]?.PQR_Certification_Welder_Name || "--"}</td>
                <td style={{border:"1px solid black", borderTop:"none", borderLeft:"none", fontSize:"7.6px", textAlign:"center", padding:"0px 3px", backgroundColor:"white"}}>{pdf[0]?.Certification?.[1]?.PQR_Certification_ID || "--"}</td>
                <td style={{border:"1px solid black", borderTop:"none", borderLeft:"none", fontSize:"7.6px", textAlign:"center", padding:"0px 3px", backgroundColor:"white"}}>{pdf[0]?.Certification?.[1]?.PQR_Certification_Process || "--"}</td>
                <td style={{border:"1px solid black", borderTop:"none", borderLeft:"none", fontSize:"7.6px", textAlign:"left", padding:"0px 3px", backgroundColor:"white"}} colSpan={2}>{pdf[0]?.CertificationLabRef?.[0]?.PQR_Certification_Lab_RefNo || "--"}</td>
              </tr>
              <tr style={{height:"10px"}}>
                <td style={{border:"1px solid black", borderTop:"none", fontSize:"7.6px", textAlign:"center", padding:"0px 3px", backgroundColor:"white"}}>{pdf[0]?.Certification?.[2]?.PQR_Certification_Welder_Name || "--"}</td>
                <td style={{border:"1px solid black", borderTop:"none", borderLeft:"none", fontSize:"7.6px", textAlign:"center", padding:"0px 3px", backgroundColor:"white"}}>{pdf[0]?.Certification?.[2]?.PQR_Certification_ID || "--"}</td>
                <td style={{border:"1px solid black", borderTop:"none", borderLeft:"none", fontSize:"7.6px", textAlign:"center", padding:"0px 3px", backgroundColor:"white"}}>{pdf[0]?.Certification?.[2]?.PQR_Certification_Process || "--"}</td>
                <td style={{border:"1px solid black", borderTop:"none", borderLeft:"none", fontSize:"7.6px", textAlign:"left", padding:"0px 3px", backgroundColor:"white"}} colSpan={2}>{pdf[0]?.CertificationLabRef?.[1]?.PQR_Certification_Lab_RefNo || "--"}</td>
              </tr>
              <tr style={{height:"10px"}}>
                <td style={{border:"1px solid black", borderTop:"none", fontSize:"7.6px", textAlign:"center", padding:"0px 3px", backgroundColor:"white"}}>{pdf[0]?.Certification?.[3]?.PQR_Certification_Welder_Name || "--"}</td>
                <td style={{border:"1px solid black", borderTop:"none", borderLeft:"none", fontSize:"7.6px", textAlign:"center", padding:"0px 3px", backgroundColor:"white"}}>{pdf[0]?.Certification?.[3]?.PQR_Certification_ID || "--"}</td>
                <td style={{border:"1px solid black", borderTop:"none", borderLeft:"none", fontSize:"7.6px", textAlign:"center", padding:"0px 3px", backgroundColor:"white"}}>{pdf[0]?.Certification?.[3]?.PQR_Certification_Process || "--"}</td>
                <td style={{border:"1px solid black", borderTop:"none", borderLeft:"none", backgroundColor:"white"}} colSpan={2}></td>
              </tr>
            </table>
          </div>
      <p className="PQRcertifont" style={{position:"relative", zIndex:10, margin:"3px 0px"}}>We certify that the statements in this record are correct and that the test welds were prepared, welded, and tested in accordance with the requirements of Section IX of the ASME Boiler and Pressure Vessel Code.</p>
      <div id="footer" style={{position:"fixed", top:"935px"}} >
        <PQR_Footer pdf={pdf} previewuser={previewuser} previewapproved={previewapproved}></PQR_Footer>
      </div>
      <br></br>
      <div id="footer" style={{position:"fixed",top:"1015px"}} >
        <table className="WPSfooter">
          <tr>
            <td>Page 1 of 3</td>
          </tr>
        </table>
      </div>
    

    </div>
  );
};

export default PQRTubeToTubesheet_pdf_page1;
